export class FocusOut {
   private readonly host: HTMLElement;
   private readonly callback: () => void;

   constructor(args: {
      host: HTMLElement;
      callback: () => void;
   }) {
      this.host = args.host;
      this.callback = args.callback;
   }

   public handler = (e: FocusEvent) => {
      const target = e.relatedTarget as HTMLElement;
      let parent: HTMLElement = target;

      while(parent !== document.body && parent) {
         parent = parent.parentElement;
         if (parent === this.host) {
            return null;
         }
      }
      this.callback();     
   }
}